import React from 'react';
import PropTypes from 'prop-types';
import { BasicInput, BaasicButton } from 'core/components';
import {defaultTemplate} from 'core/hoc';

function PasswordChangeTemplate({ currentView, t }) {
    const { passwordChangeForm, goToLogin } = currentView;

    return <section>
        <div className='login__top'>
            <img className='login__top__logo' src={require('themes/assets/img/logo.svg')} alt='Logo' />
        </div>
        <div className='container--login'>
            <form className="form card card--lrg card--primary" onSubmit={passwordChangeForm.onSubmit}>
                <h1 className='u-mar--bottom--med'>{t('PASSWORD_CHANGE.NEW_PASSWORD_PLACEHOLDER')}</h1>
                <div className='form__group u-mar--bottom--med'>
                    <BasicInput field={passwordChangeForm.$('password')} />
                </div>
                <div className='form__group u-mar--bottom--med'>
                    <BasicInput field={passwordChangeForm.$('confirmPassword')} />
                </div>
                {
                    passwordChangeForm.error && (
                        <div>
                            <p className="type--color--warning">{passwordChangeForm.error}</p>
                        </div>
                    )
                }
                <div className='u-group'>
                    <div className='u-pull'>
                        <BaasicButton className='btn btn--base btn--primary' type='submit' label={t('SAVE')} disabled={passwordChangeForm.submitting || !passwordChangeForm.isValid} />
                    </div>
                    <div className='u-push'>
                        <a className='btn btn--link btn--base btn--base--link u-mar--top--tny display--ib' onClick={goToLogin}>{t('CANCEL')}</a>
                    </div>
                </div>
            </form>
        </div>
    </section>
}

PasswordChangeTemplate.propTypes = {
    currentView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PasswordChangeTemplate);